module.exports = __webpack_public_path__ + "img/building-suppliers.da89cde1.svg";